<template>
    <div class="main">
        <div class="container">
            <div class="xmgj">
                <div class="xmgjInfo">
                    <img src="../assets/imgs/xmxxPad.png" class="xmgjBg" />
                    <img src="../assets/imgs/padBg.png" class="padxmgjBg" />
                    <img src="../assets/imgs/padButton.png" class="padDownLoad" @click="downLoadApp('xmxxpad')" />
                    <img src="../assets/imgs/padButtonView.png" class="padbtn" @click="downLoadApp('xmxxpad')" />
                    <div class="QRbox">
                        <img src="../assets/imgs/QRcode.png" class="QRcode" />
                        <div class="info">
                            <span class="topTitle">扫描二维码下载</span>
                            <span>小马鲜鲜平板应用</span>
                        </div>
                    </div>
                    <div class="copyright">
                        <p>Copyright © 2021 小马国炬 版权所有</p>
                    </div>
                </div>
                <DownLoadTip ref="downloadTip"></DownLoadTip>
            </div>
            <div class="wxtip" id="JweixinTip">
                <div class="flex">
                    <span class="close" @click="closetip()">×</span>
                    <span class="wxtip-icon img">
                        <img src="../assets/tip.png" alt="" />
                    </span>
                </div>
                <p class="wxtip-txt">点击右上角<br />选择在浏览器中打开</p>
            </div>
            <div class="load" style="display:none">
                <p></p>
            </div>
            <div class="mask" style="display: none;">
                <div class="alert">
                    <div class="descript"></div>
                    <div class="confirm">
                        <button class="confirmBtn" type="button" @click="closemask()">确定</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
// 判断ios/android
<script src="./config/env.js"></script>
//
<script type="text/javascript" src="https://res.wx.qq.com/open/js/jweixin-1.6.0.js"></script>
//
<script src="http://m-cdn.saclub.com.cn/app/2.4/js/jquery-1.11.3.min.js"></script>
<script src="https://code.jquery.com/jquery-3.1.1.min.js"></script>
<script type="text/javascript">
import { API_URL } from "@/fetch/fetch";
import DownLoadTip from '../components/DownLoadTip.vue'
import Util from '../utils/index.js'
export default {
    components: { DownLoadTip },
    data() {
        return {
            navtype: 1,
        };
    },
    mounted() {
        this.isWeiXin();
        window.addEventListener("scroll", this.handleScroll); // 监听滚动事件，然后用handleScroll这个方法进行相应的处理
        // this.closetip();
    },
    methods: {
        handleScroll() {
            console.log(11111111);
        },
        isWeiXin() {
            //是否是微信打开，并且提示引导
            var ua = window.navigator.userAgent.toLowerCase();
            //mozilla/5.0 (iphone; cpu iphone os 9_1 like mac os x) applewebkit/601.1.46 (khtml, like gecko)version/9.0 mobile/13b143 safari/601.1
            if (ua.match(/MicroMessenger/i) == "micromessenger") {
                $("#JweixinTip").attr("style", "display:none;");
                return true;
            } else {
                $("#JweixinTip").attr("style", "display:none;");
                return false;
            }
        },
        closetip() {
            //隐藏div
            $("#JweixinTip").attr("style", "display:none;"); //隐藏div
        },
        downLoadApp(name) {
            let flag = Util.judgeFlag()
            this.$store.commit('CHANGE_DOWNLOADNAME',name)
            this.$store.commit('CHANGE_TYPE',2)
            if(flag){
                this.$store.commit('CHANGE_SHOW',name)
                return
            }
            Util.downLoadApp()
        },
        changeNavBar(val) {
            this.navtype = val;
        },
        closemask() {
            $(".mask").css("display", "none");
        },
    },
};
</script>

<style lang="scss" scoped>
.main {
    height: 100%;
    width: 100vw;
    background-color: #f2f2f2;
    overflow: scroll;
}
.flexR {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}
.header {
    width: 100%;
    height: 96px;
    background-color: #fff;
    font-size: 28px;
    position: fixed;
    top: 0;
    backdrop-filter: blur(20px);
    background-color: rgba(255, 255, 255, 0.5);
    z-index: 1;
    .logo {
        width: 191px;
        height: 48px;
        padding-left: 32px;
    }
    .appstore {
        color: #666666;
    }
    .pageName {
        padding-right: 32px;
        padding-left: 24px;
        margin-left: 24px;
        color: #666666;
        border-left: 1px solid rgba(0, 0, 0, 0.3);
    }
}
.container {
    width: 100%;
    height: 100%;
    position: relative;
    position: absolute;
    background-color: #fff;
    @media screen and (max-width: 768px) {
        .xmgjBg {
            width: 100%;
            display: block;
        }
        .padxmgjBg {
            display: none;
        }
        .padbtn {
            display: none;
        }
        .padDownLoad {
            width: 70%;
            margin-top: 80px;
        }
    }
    @media screen and (min-width: 768px) {
        .xmgjBg {
            display: none;
        }
        .padDownLoad {
            display: none;
        }
        .padxmgjBg {
            width: 100%;
            height: 100%;
            display: block;
        }
        .padbtn {
            width: 25%;
            margin-top: 35px;
        }
    }
    // 小马国炬板块
    .xmgjInfo {
        // height: 272px;
        width: 100%;
        position: absolute;
        // top: 56px;
        text-align: center;
        .line {
            width: 40px;
            height: 8px;
            background: linear-gradient(135deg, #4a83f7 0%, #4a83f7 0%, #2b66f6 100%);
            border-radius: 0px 0px 0px 0px;
            opacity: 1;
            margin: auto;
            margin-bottom: 36px;
        }
        .name {
            color: #262626;
            font-size: 56px;
            font-weight: bold;
            margin-bottom: 4px;
        }
        .introduce {
            font-size: 26px;
            font-weight: 400;
            color: #939599;
            margin-bottom: 36px;
        }
        ::v-deep .el-button--primary {
            width: 275px;
            height: 74px;
            background: #2a74f4 linear-gradient(135deg, #4a83f7 0%, #4a83f7 0%, #2b66f6 100%);
            opacity: 1;
        }
        ::v-deep .el-button {
            font-size: 32px;
            font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
            font-weight: 400;
            color: #ffffff;
        }
    }

    // 更多应用
    .more {
        margin-top: 56px;
        padding: 0 40px;
        margin-bottom: 21px;
        .line {
            width: 40px;
            height: 8px;
            background: linear-gradient(135deg, #d2e0fd 0%, #dce5fa 0%, #b0bad3 100%);
            border-radius: 0px 0px 0px 0px;
            opacity: 1;
            margin-bottom: 36px;
        }
        .name {
            width: 224px;
            height: 78px;
            font-size: 56px;
            font-family: PingFang SC-Semibold, PingFang SC;
            font-weight: bold;
            color: #262626;
        }
        .moreImg {
            width: 382px;
            height: 52px;
        }
    }
    // 所有应用
    .appCell {
        position: relative;
        background-color: #f2f2f2;
        .cellInfo {
            height: 287px;
            position: absolute;
            top: 71px;
            text-align: center;
            // width: 100%;
            // display: flex;
            // flex-direction: row;
            // justify-content: space-between;
            .appLogo {
                width: 104px;
                height: 104px;
                margin-bottom: 16px;
            }
            .name {
                height: 45px;
                font-size: 32px;
                font-family: PingFang SC-Medium, PingFang SC;
                font-weight: bold;
                color: #262626;
            }
            .introduce {
                font-size: 24px;
                font-weight: 400;
                color: #939599;
                margin-bottom: 24px;
            }
            ::v-deep .el-button--primary {
                width: 192px;
                height: 60px;
                background: #2a74f4 linear-gradient(135deg, #4a83f7 0%, #4a83f7 0%, #2b66f6 100%);
                opacity: 1;
            }
            ::v-deep .el-button {
                font-size: 24px;
                font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
                font-weight: 400;
                color: #ffffff;
            }
        }
        .appBg {
            width: 718px;
            height: 370px;
            margin-bottom: 21px;
        }
    }
    .leftBox {
        padding-left: 32px;
    }
    .leftInfo {
        margin-left: 52px;
    }
    .rightInfo {
        margin-left: 427px;
    }
    .copyright {
        // background-color: #f2f2f2;
        padding: 24px 0 40px 0;
        text-align: center;
        font-size: 24px;
        color: #999999;
    }
}

::v-deep .el-button.is-round {
    border-radius: 87px 87px 87px 87px;
}

.wxtip {
    background: rgba(0, 0, 0, 0.8);
    text-align: center;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 998;
    display: none;
}

#JweixinTip .flex {
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    top: 40px;
    left: 40px;
    width: 96%;
    margin: 0 auto;
    color: white;
}
.wxtip-icon {
    width: 52px;
    height: 67px;
    display: block;
    position: absolute;
    right: 20px;
}
.wxtip-icon img {
    width: 100%;
    height: 80px;
    right: 50px;
    position: absolute;
    top: 15px;
}
.wxtip-txt {
    margin-top: 80px;
    color: #fff;
    font-size: 26px;
}
.close {
    font-size: 46px;
}
.active {
    font-weight: 700;
    color: #333;
}
.noactive {
    font-weight: 400;
    color: #666;
}
.load {
    height: 100%;
    position: absolute;
    z-index: 33;
    display: flex;
    top: 0;
    background: #2b2929;
    width: 100%;
    color: #fff;
    display: none;
    justify-content: center;
    align-items: center;
    font-size: 22px;
    opacity: 0.9;
}
.load p {
    position: absolute;
}
.mask {
    position: fixed;
    display: flex;
    display: webkit-flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 999999;
    background: #0000002b;
    box-sizing: border-box;
}
.alert {
    // min-width: 240px;
    // max-width: 320px;
    width: 70%;
    background: #fff;
    border-radius: 6px;
    color: #1f0000;
    overflow: hidden;
    box-sizing: border-box;
}
.descript {
    padding: 24px 16px 8px 16px;
    text-align: center;
    letter-spacing: 1px;
    font-size: 32px;
    color: #1f0000;
    box-sizing: border-box;
}
.confirm {
    box-sizing: border-box;
    width: 100%;
    padding: 8px;
    padding-top: 0px;
    text-align: center;
    box-sizing: border-box;
    background: #fff;
}
.confirmBtn {
    cursor: pointer;
    padding: 14px 10px;
    border: none;
    border-radius: 2px;
    font-size: 32px;
    color: #3f8bdc;
    background-color: transparent;
    box-sizing: border-box;
}

@media screen and (max-width: 768px) {
    .QRbox {
        display: block;
        padding: 80px 70px 20px 70px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }
    .QRcode {
        width: 100px;
        height: 100px;
    }

    .info {
        display: flex;
        flex-direction: column;
        font-size: 20px;
        color: #666;
    }
    .topTitle {
        margin-bottom: 8px;
    }
}
@media screen and (min-width: 768px) {
    .QRbox {
        display: none;
    }
}
</style>
